import { render, staticRenderFns } from "./LineSetting.vue?vue&type=template&id=5834170d&scoped=true&"
import script from "./LineSetting.vue?vue&type=script&lang=js&"
export * from "./LineSetting.vue?vue&type=script&lang=js&"
import style0 from "./LineSetting.vue?vue&type=style&index=0&id=5834170d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5834170d",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VColorPicker,VDialog,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5834170d')) {
      api.createRecord('5834170d', component.options)
    } else {
      api.reload('5834170d', component.options)
    }
    module.hot.accept("./LineSetting.vue?vue&type=template&id=5834170d&scoped=true&", function () {
      api.rerender('5834170d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/LineSetting.vue"
export default component.exports